import { AxiosResponse } from 'axios';
import { SET_LEAVE_BALANCES, SET_LEAVE_BALANCE, SET_ERRORMSG } from '@/store/mutation_types';
import {
  CLEAR_LEAVE_BALANCE_ISLOADING,
  DELETE_LEAVE_BALANCE,
  EDIT_LEAVE_BALANCE,
  GET_LEAVE_BALANCES,
  GET_LEAVE_BALANCE,
  REGISTER_LEAVE_BALANCE,
} from '@/store/action_types';
import { StateObject } from '@/dtos/state.dto';
import LeaveBalance from '@/services/leave_balance';
import { Module } from 'vuex';
import { EditLeaveBalance, RegisterLeaveBalance, GetLeaveBalance } from '@/dtos/leave_balance.dto';

const leaveBalance: Module<any, {}> = {
  state: {
    leaveBalance: {
      data: null,
      isLoading: false,
    },
    leaveBalances: {
      data: null,
      isLoading: false,
    },
  },
  getters: {
    leaveBalance: (state: { leaveBalance: any }) => state.leaveBalance,
    leaveBalances: (state: { leaveBalances: any }) => state.leaveBalances,
  },
  mutations: {
    [SET_LEAVE_BALANCE]: (
      state: { leaveBalance: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.leaveBalance.data = payload.data) : null,
        (state.leaveBalance.isLoading = payload.isLoading);
    },
    [SET_LEAVE_BALANCES]: (
      state: { leaveBalances: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.leaveBalances.data = payload.data) : null,
        (state.leaveBalances.isLoading = payload.isLoading);
    },
  },
  actions: {
    [REGISTER_LEAVE_BALANCE]: async ({ commit }: any, payload: any) => {
      commit(SET_LEAVE_BALANCE, { data: null, isLoading: true });

      const result: AxiosResponse = await LeaveBalance.registerLeaveBalance(
        payload as RegisterLeaveBalance
      );

      if (result) {
        if (result.data.status) {
          commit(SET_LEAVE_BALANCE, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_LEAVE_BALANCE, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_LEAVE_BALANCE, { isLoading: false });
        return false;
      }
    },
    [GET_LEAVE_BALANCES]: async ({ commit }: any, payload: any) => {
      commit(SET_LEAVE_BALANCES, { data: null, isLoading: true });

      const result: AxiosResponse = await LeaveBalance.getLeaveBalances(
        payload as GetLeaveBalance
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_LEAVE_BALANCES, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_LEAVE_BALANCES, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_LEAVE_BALANCES, { isLoading: false });
        return false;
      }
    },
    [GET_LEAVE_BALANCE]: async ({ commit }: any, payload: any) => {
      commit(SET_LEAVE_BALANCES, { data: null, isLoading: true });

      const result: AxiosResponse = await LeaveBalance.getLeaveBalances(
        payload as GetLeaveBalance
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_LEAVE_BALANCES, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_LEAVE_BALANCES, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_LEAVE_BALANCES, { isLoading: false });
        return false;
      }
    },
    [EDIT_LEAVE_BALANCE]: async ({ commit }: any, payload: any) => {
      commit(SET_LEAVE_BALANCE, { data: null, isLoading: true });

      const result: AxiosResponse = await LeaveBalance.editLeaveBalance(
        payload as EditLeaveBalance
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_LEAVE_BALANCE, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_LEAVE_BALANCE, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_LEAVE_BALANCE, { isLoading: false });
        return false;
      }
    },
    [DELETE_LEAVE_BALANCE]: async ({ commit }: any, payload: string) => {
      commit(SET_LEAVE_BALANCE, { data: null, isLoading: true });

      const result: AxiosResponse = await LeaveBalance.deleteLeaveBalance(payload);

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_LEAVE_BALANCE, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_LEAVE_BALANCE, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_LEAVE_BALANCE, { isLoading: false });
        return false;
      }
    },
    [CLEAR_LEAVE_BALANCE_ISLOADING]: ({ commit }) => {
      commit(SET_LEAVE_BALANCE, { isLoading: false });
      commit(SET_LEAVE_BALANCES, { isLoading: false });
    },
  },
};

export default leaveBalance;
